import { render, staticRenderFns } from "./PageMyAccount.vue?vue&type=template&id=acb84f9c&scoped=true&"
import script from "./PageMyAccount.vue?vue&type=script&lang=js&"
export * from "./PageMyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb84f9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acb84f9c')) {
      api.createRecord('acb84f9c', component.options)
    } else {
      api.reload('acb84f9c', component.options)
    }
    module.hot.accept("./PageMyAccount.vue?vue&type=template&id=acb84f9c&scoped=true&", function () {
      api.rerender('acb84f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/PageMyAccount.vue"
export default component.exports